import { ShieldCheck, Cog, Receipt, Boxes, UserCheck, Clock, BadgeCheck, Ban } from "lucide-react";
import { WHY_US } from "@/data/site";
import { FadeUp, Chapter, RevealLines } from "./motion";

const ICONS = [ShieldCheck, Cog, Receipt, Boxes, UserCheck, Clock, BadgeCheck, Ban];

export default function WhyUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="bg-[#F7F5F2] py-24 md:py-36">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 md:px-12 lg:grid-cols-[1fr_1.4fr]">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <Chapter num="03" title="Why Choose Us" />
          <RevealLines
            className="mt-8 font-display text-4xl tracking-tight text-[#1B1B1B] md:text-5xl"
            lines={[<>Promises,</>, <><span className="italic text-[#B68D40]">not</span> brochures.</>]}
          />
          <FadeUp delay={0.3}>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#2C2C2C]/65">
              Eight commitments printed on every agreement we sign. If we ever break one, the project manager's phone number is yours — it rings on Sohan's desk.
            </p>
          </FadeUp>
        </div>

        <div>
          {WHY_US.map((w, i) => {
            const Icon = ICONS[i];
            return (
              <FadeUp key={w.title} delay={i * 0.05}>
                <div
                  data-testid={`why-us-item-${i}`}
                  className="group flex items-start gap-6 border-t hairline py-8 transition-colors duration-300 last:border-b hover:bg-[#E7DDD0]/40"
                >
                  <span className="font-num text-sm text-[#B68D40]">{String(i + 1).padStart(2, "0")}</span>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border hairline-gold text-[#B68D40] transition-colors duration-300 group-hover:bg-[#B68D40] group-hover:text-[#1B1B1B]">
                    <Icon size={18} />
                  </span>
                  <div>
                    <h3 className="font-display text-xl text-[#1B1B1B] md:text-2xl">{w.title}</h3>
                    <p className="mt-2 max-w-lg text-sm leading-relaxed text-[#2C2C2C]/60">{w.desc}</p>
                  </div>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
